import React , { useState, useEffect } from 'react'
import { GeoAltFill } from 'react-bootstrap-icons'

import axios from 'axios'
import EventsMap from '../Groups/EventsMap'

const Events = () => {
  //const [events, setEvents] = useState()

  /*
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('http://localhost:3001/events');
        const data = await response.json();
        setEvents(data);
      } catch (error) {
        console.log('Error fetching events:', error);
      }
    };

    fetchData();
  }, []);

  */

  const events = [
    {name: "The Scottish Crannog Centre: A Medieval Takeover! ",
      start_date: new Date("2025-05-03"),
      end_date: new Date("2025-05-03"),
      location: "Beltane",
      description: "",
      coordinates: {y: "56.5891", x: "-4.02015"}
    },

    {name: "Bannockburn Heritage Centre",
    start_date: new Date("2024-06-23"),
    end_date: new Date("2024-06-23"),
    location: "Bannockburn Heritate Center",
    description: "From medieval combat, kids armies, Arming a Knight and a variety of craft displays in our medieval tents, come along and speak with the volunteers bringing 14th Century Scotland to life! Learn about the crafts and skills of the time, watch the training that goes into becoming a Knight, get a close-up view of the armour and weapons and discover the laws of the time at the Court of the local Lord.",
    coordinates: {y: "56.09261", x: "-3.93507"}
  }

  ]

  return (
    <>
    <header className=" flex flex-wrap ">
    <div className="hero2 flex flex-col items-center w-full py-40">
            <h1 className="text-2xl font-bold leading-snug tracking-tight text-gray-300 lg:text-3xl lg:leading-tight xl:text-3xl xl:leading-tight ">
          Events 2025
        </h1>
    </div>
  </header>
  <section>

    <div class=" text-left  md:w-60vw w-80vw " >
      {events?.sort((a,b) => a.start_date - b.start_date).filter((event) => event.end_date > new Date()).map((event) => 
        <div key={event.name} className='bg-white  border  md:w-auto p-8 mb-8 '>        
            <div className='flex gap-4 flex-col'>
             <b className=''>{event.start_date.toLocaleDateString() } - {event.end_date.toLocaleDateString() }</b>
              <h3 className='text-xl'>{event.name} </h3>
              <p className='opacity-80 italic font-light'>{event.description}</p>
              <a href={"https://www.google.com/maps/dir//" + event.location} target="_blank"  className='flex items-center gap-1'><GeoAltFill className='text-sky-500 text-xl'/>{event.location}</a>
            </div>
        </div>
      )}

     <table class="min-w-full table-auto border border-gray-300">
      <thead class="bg-gray-200">
        <tr>
          <th class="px-4 py-2 text-left">Event</th>
          <th class="px-4 py-2 text-left">Date</th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-300">
        <tr><td class="px-4 py-2">Beltane</td><td class="px-4 py-2">3rd May</td></tr>
        <tr><td class="px-4 py-2">Traquair House</td><td class="px-4 py-2">24th - 25th May</td></tr>
        <tr><td class="px-4 py-2">Dunfermline</td><td class="px-4 py-2">31st May - 1st June</td></tr>
        <tr><td class="px-4 py-2">Craigmillar Castle</td><td class="px-4 py-2">7th June</td></tr>
        <tr><td class="px-4 py-2">St Andrews</td><td class="px-4 py-2">8th June</td></tr>
        <tr><td class="px-4 py-2">Newhailes House</td><td class="px-4 py-2">14th June</td></tr>
        <tr><td class="px-4 py-2">Linlithgow Palace</td><td class="px-4 py-2">28th - 29th June</td></tr>
        <tr><td class="px-4 py-2">The Crannog Centre</td><td class="px-4 py-2">12th - 13th July</td></tr>
        <tr><td class="px-4 py-2">Caerlaverock Castle</td><td class="px-4 py-2">26th - 27th July</td></tr>
        <tr><td class="px-4 py-2">Battle of Evesham</td><td class="px-4 py-2">1st - 3rd August</td></tr>
        <tr><td class="px-4 py-2">Roman Day</td><td class="px-4 py-2">27th September</td></tr>
      </tbody>
    </table>

  </div>
  <br />

  </section>

  <div id="map" class=" bg-sky-500 w-full " >

    <EventsMap events={events}/>




</div>
  </>    
  )
}

export default Events